import React, { useMemo } from 'react'
import dayjs from 'dayjs'

import './style.scss'
import RegistrationHelper from 'general/helpers/RegistrationHelper'
import Utils, { getTaxCodeCompany } from 'general/utils/Utils'

function Message213(props) {
  const { message } = props
  console.log('message', message)
  const isSent = useMemo(() => message.messageId?.startsWith('V'), [message])
  const NNhan = useMemo(
    () => message.contentRaw?.TDiep?.DLieu?.TBao?.DLTBao?.TGGui,
    [message],
  )
  const isMessageValid = message?.refErrAnnouceMessageId
    ? message.contentRaw?.TDiep?.DLieu?.TBao?.DLTBao?.KHLKhac?.DSLDo?.LDo
    : message.contentRaw?.TDiep?.DLieu?.TBao?.DLTBao?.LCTu?.DSCTu?.CTu?.DSLDo
        ?.LDo

  const So = useMemo(
    () => message.contentRaw?.TDiep?.DLieu?.TBao?.DLTBao?.So,
    [message],
  )

  const LDos = useMemo(() => {
    let LDos = message?.refErrAnnouceMessageId
      ? message.contentRaw?.TDiep?.DLieu?.TBao?.DLTBao?.KHLKhac?.DSLDo?.LDo
      : message.contentRaw?.TDiep?.DLieu?.TBao?.DLTBao?.LCTu?.DSCTu?.CTu?.DSLDo
          ?.LDo
    if (!LDos) return

    return Array.isArray(LDos) ? LDos : [LDos]
  }, [message])

  return (
    <div className="Message213 border-bottom mb-5">
      {message?.refErrAnnouceMessageId ? (
        <div className="d-flex flex-row">
          <div style={{ maxWidth: '500px' }}>
            <p className="mb-2">
              <span
                style={{
                  width: '18px',
                  height: '18px',
                  backgroundColor: !isMessageValid ? '#00B416' : '#FF5563',
                  textAlign: 'center',
                  borderRadius: '100%',
                  marginRight: '6px',
                  display: 'inline-flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <i
                  className={`fa-regular ${
                    isSent ? 'fa-arrow-up' : 'fa-arrow-down'
                  }  text-white  `}
                  style={{
                    fontSize: '12px',
                  }}
                ></i>
              </span>
              <span className="text-time">
                {NNhan && dayjs(NNhan).format('DD/MM/YYYY hh:mm:ss')}
              </span>
            </p>

            <p className="mb-2">
              {`[${
                message.typeCode
              }] ${message.contentRaw?.TDiep?.DLieu?.TBao?.DLTBao?.Ten}`}
            </p>
            {LDos && (
              <div className="p-3" style={{ backgroundColor: '#fff3cd' }}>
                {LDos?.map(({ MLoi, MTLoi, HDXLy }, index) => (
                  <>
                    <p key={index} className="mb-2">
                      {`Mã lỗi: [${MLoi}]. `}
                      {MTLoi}
                    </p>
                    {HDXLy && (
                      <p key={index} style={{ color: '#5180fb' }}>
                        <a>{`Hướng dẫn xử lý cho mã lỗi [${MLoi}]: ${HDXLy} `}</a>
                      </p>
                    )}
                  </>
                ))}
              </div>
            )}

            <p className="my-2">
              Số thông báo:{' '}
              <a href="#" title="Xem thông báo">
                {So}
              </a>
            </p>

            <p className="mb-2" style={{ color: '#c4c4c4' }}>
              {`Mã thông điệp: ${message.messageId}`}
            </p>
          </div>
          <div className="text-right flex-fill">
            <p className="mb-2 font-weight-bold">
              {isSent
                ? getTaxCodeCompany(process.env.REACT_APP_SEARCH_PAGE_URL)
                : 'Cơ quan thuế'}
            </p>

            <p className="mb-2">
              <span
                style={{
                  fontWeight: '500',
                  fontSize: '13.2px',
                  lineHeight: '16px',
                  borderRadius: '10px',
                  backgroundColor: !isMessageValid ? '#E5F1E8' : '#FFEEEE',
                  color: !isMessageValid ? '#20A144' : '#EE2334',
                  padding: '4px 10px',
                }}
              >
                {!isMessageValid ? 'CQT chấp nhận' : 'CQT Không chấp nhận'}
              </span>
            </p>

            <p
              className="mb-2 cursor-pointer"
              onClick={() => {
                Utils.exportXmlFile({
                  data: message.contentRaw.TDiep,
                  fileName: 'thong-diep-213',
                })
              }}
              title="Xuất khẩu XML"
            >
              <i
                className="fa-regular fa-download"
                style={{ color: 'inherit' }}
              ></i>
            </p>
          </div>
        </div>
      ) : (
        <div className="d-flex flex-row">
          <div style={{ maxWidth: '500px' }}>
            <p className="mb-2">
              <span
                style={{
                  width: '18px',
                  height: '18px',
                  backgroundColor: !isMessageValid ? '#00B416' : '#FF5563',
                  textAlign: 'center',
                  borderRadius: '100%',
                  marginRight: '6px',
                  display: 'inline-flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <i
                  className={`fa-regular ${
                    isSent ? 'fa-arrow-up' : 'fa-arrow-down'
                  }  text-white  `}
                  style={{
                    fontSize: '12px',
                  }}
                ></i>
              </span>
              <span className="text-time">
                {NNhan && dayjs(NNhan).format('DD/MM/YYYY hh:mm:ss')}
              </span>
            </p>

            <p className="mb-2">
              {`[${
                message.typeCode
              }] ${message.contentRaw?.TDiep?.DLieu?.TBao?.DLTBao?.Ten}`}
            </p>
            {LDos && (
              <div className="p-3" style={{ backgroundColor: '#fff3cd' }}>
                {LDos?.map(({ MLoi, MTLoi, HDXLy }, index) => (
                  <>
                    <p key={index} className="mb-2">
                      {`Mã lỗi: [${MLoi}]. `}
                      {MTLoi}
                    </p>
                    {HDXLy && (
                      <p key={index} style={{ color: '#5180fb' }}>
                        <a>{`Hướng dẫn xử lý cho mã lỗi [${MLoi}]: ${HDXLy} `}</a>
                      </p>
                    )}
                  </>
                ))}
              </div>
            )}

            <p className="my-2">
              Số thông báo:{' '}
              <a href="#" title="Xem thông báo">
                {So}
              </a>
            </p>

            <p className="mb-2" style={{ color: '#c4c4c4' }}>
              {`Mã thông điệp: ${message.messageId}`}
            </p>
          </div>
          <div className="text-right flex-fill">
            <p className="mb-2 font-weight-bold">
              {isSent
                ? getTaxCodeCompany(process.env.REACT_APP_SEARCH_PAGE_URL)
                : 'Cơ quan thuế'}
            </p>

            <p className="mb-2">
              <span
                style={{
                  fontWeight: '500',
                  fontSize: '13.2px',
                  lineHeight: '16px',
                  borderRadius: '10px',
                  backgroundColor: !isMessageValid ? '#E5F1E8' : '#FFEEEE',
                  color: !isMessageValid ? '#20A144' : '#EE2334',
                  padding: '4px 10px',
                }}
              >
                {!isMessageValid ? 'CQT chấp nhận' : 'CQT Không chấp nhận'}
              </span>
            </p>

            <p
              className="mb-2 cursor-pointer"
              onClick={() => {
                Utils.exportXmlFile({
                  data: message.contentRaw.TDiep,
                  fileName: 'thong-diep-213',
                })
              }}
              title="Xuất khẩu XML"
            >
              <i
                className="fa-regular fa-download"
                style={{ color: 'inherit' }}
              ></i>
            </p>
          </div>
        </div>
      )}
    </div>
  )
}

export default Message213
